import "./index.less";

import { FC, useEffect } from "react";
import { useSelector } from "react-redux";

import { Carousel } from "antd";

// import {
//   FormOutlined,
//   MessageOutlined,
//   FileDoneOutlined,
//   OrderedListOutlined,
// } from "@ant-design/icons";

// import Grid from "../grid";
// import userHeader from "@/layout/image/logo.png";

import { routerJump } from "@/util/tools";

import { useHistory } from "react-router-dom";

import { TStoreData } from "@/interface";

const contentStyle: any = {
  height: "80px",
  color: "#fff",
  lineHeight: "80px",
  textAlign: "left",
  padding: "0 0 0 10px",
  background: "#364d79",
};

export const UserInfo: FC = () => {
  const history = useHistory();

  const store = useSelector((data: TStoreData) => {
    return {
      user: data?.user || {},
      userProcess: data?.userProcess || [],
      subMenuList: data?.subMenuList || [],
    };
  });
  const {
    user,
    user: { deptFullNameList },
    userProcess,
  } = store;
  const currentMessage = (i) => {
    const stateIndex =
      Array.isArray(i.trackTasks) &&
      i.trackTasks.findIndex((it) => it.taskType == i.currentStatus);
    const state =
      Array.isArray(i.trackTasks) && stateIndex + 1 <= i.trackTasks.length
        ? i.trackTasks[stateIndex + 1]
        : {};
    return state.assigneeName &&
      state.taskName &&
      typeof state.taskName.replaceAll === "function"
      ? state.assigneeName + state.taskName.replaceAll("&nbsp;", "")
      : "";
  };
  useEffect(() => {}, [user]);
  return (
    <div>
      <div className={`lr-home-right_user`}>
        {/*  <img src={userHeader} className={`lr-home-right_user_header`} alt="" /> */}
        <div className={`lr-home-right_user_name`}>{user.nick}</div>
        <span className={`lr-home-right_user_name-box`}>
          <div className={`lr-home-right_user_grid`}>
            {deptFullNameList?.join?.(" ")}
          </div>
        </span>
        {/* <div className={`lr-home-right_user_icon_box`}>
          <span className={`lr-home-right_user_icon`}>
            <FormOutlined /> 待审批 ｜
          </span>
          <span className={`lr-home-right_user_icon`}>
            <FileDoneOutlined /> 代办 ｜
          </span>
          <span className={`lr-home-right_user_icon`}>
            <OrderedListOutlined /> 任务 ｜
          </span>
          <span className={`lr-home-right_user_icon`}>
            <MessageOutlined /> 消息
          </span>
        </div> */}
      </div>
      {/* <div className={`home-grid_box`}>
        <Grid />
      </div> */}
      <div className={`home-news_box`}>
        <Carousel dotPosition={"right"} autoplay={true} dots={false}>
          {(userProcess &&
            userProcess.map((i) => (
              <div key={i.processDefinitionName}>
                <h3 style={contentStyle} onClick={() => routerJump(history, i)}>
                  {i.processDefinitionName + " " + currentMessage(i)}
                </h3>
              </div>
            ))) ||
            "暂无待办信息"}
        </Carousel>
      </div>
    </div>
  );
};

export default UserInfo;
